import { Checkbox } from '@/components'
import { FilterInputWrapper } from './FilterInputWrapper'
import type { SelectInputProps } from './types'

export function SelectInput({
  label = 'Select',
  options,
  value = [],
  onChange,
  multiple = true,
  emptyMessage = 'No options available',
}: SelectInputProps) {
  const handleToggle = (item: string, checked: boolean) => {
    if (multiple) {
      if (checked) {
        onChange([...value, item])
      } else {
        onChange(value.filter((v) => v !== item))
      }
    } else {
      onChange(checked ? [item] : [])
    }
  }

  return (
    <FilterInputWrapper label={label} gap={3}>
      <div className="max-h-75 overflow-y-auto border rounded-md p-2 space-y-0.5 scrollbar-thin scrollbar-thumb-neutral-300 hover:scrollbar-thumb-neutral-400 scrollbar-track-transparent">
        {options.length === 0 && (
          <p className="px-2 py-3 text-sm text-muted-foreground text-center">
            {emptyMessage}
          </p>
        )}
        {options.map((option) => {
          const {
            value: optionValue,
            label: optionLabel,
            description: optionDescription,
          } = typeof option === 'object'
            ? option
            : { value: option, label: option, description: undefined }
          const isChecked = Array.isArray(value)
            ? value.includes(optionValue)
            : value === optionValue

          return (
            <label
              key={optionValue}
              className="flex items-start gap-2 cursor-pointer hover:bg-blue-2 px-2 py-1.5 rounded-md transition-colors"
              htmlFor={optionValue}
            >
              <Checkbox
                id={optionValue}
                checked={isChecked}
                onCheckedChange={(checked: boolean | 'indeterminate') =>
                  handleToggle(optionValue, checked as boolean)
                }
                className="mt-0.5"
              />
              <div className="flex flex-col min-w-0 flex-1">
                <span className="text-sm font-medium truncate">
                  {optionLabel}
                </span>
                {optionDescription && (
                  <span className="text-xs text-muted-foreground truncate">
                    {optionDescription}
                  </span>
                )}
              </div>
            </label>
          )
        })}
      </div>
    </FilterInputWrapper>
  )
}
